import { AvailableStore } from '../services/Appointment/model';

export const getStore = (
  storeId: string,
  stores: AvailableStore[] = [],
): AvailableStore | undefined => {
  return stores.find(
    (store: AvailableStore): boolean => store.value === storeId,
  );
};
